<template>

	<!-- Layout Footer -->
	<a-layout-footer>
		
		<!-- Copyright Notice -->
		<p class="copyright">
			Copyright © {{ moment().format("YYYY") }} <span class="text-dark">BoutIQ</span>
			by <a href="https://tamtam-technology.com" target="_blank" class="text-dark">TamTam-Technology.com</a>.
		</p>
		<!-- / Copyright Notice -->

	</a-layout-footer>
	<!-- / Layout Footer -->

</template>

<script>

	import moment from "moment"
	export default ({
		data() {
			return {
			}
		},
	})

</script>

<style lang="scss" scoped>

	.nav-link svg {
		margin-right: 5px;
		vertical-align: middle;
	}
	.nav-link span {
		vertical-align: middle;
	}
	.ant-menu-submenu-popup {
		width: 100%;
	}

</style>